if (window.location.pathname != '/' && sessionStorage.getItem('bikeName')) {
// document.querySelector("#shopify-section-header > div:nth-child(2) > div > header > div > div.logo-nav-contain").style.marginTop = 0;
    }
// window.addEventListener('load', () => {
window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.page .wrapper .narrow')) {    
  // console.log(document.querySelector('.page .wrapper .narrow'))
  document.querySelector('.page .wrapper .narrow').classList.add('ymm4col')
  }
    if (!sessionStorage.getItem('fitments') && document.querySelector('nav.breadcrumb')){
    document.querySelector('nav.breadcrumb').style.marginTop = '90px';
    //document.querySelector('.product-fit-indicator').style.display = 'none';
    }

  if(sessionStorage.getItem('fitments')) {
let fitments = sessionStorage.getItem('fitments').split(',').map(i => i.replaceAll(' ','%20').replaceAll('\u0026','%26')).join('%7C')
    if (document.querySelector('header.content-util')) {
    // document.querySelector('header.content-util').style.marginBottom = '-25px';
    }
// document.querySelector('.gl_d_searhbox').action = "/pages/search-results-page";
let anchors = document.getElementsByTagName('a');

      for (var i = 0; i < anchors.length; i++) {
        if (anchors[i].href.includes('/collections') && !anchors[i].href.includes('/products')){
          anchors[i].href = anchors[i].href.replace('/collections/','/pages/search-results-page?collection=') + '&rb_filter_metafield_b8d8fc4e5143be2d0daae1f33d4de73b=' + fitments
        }else if (anchors[i].href.includes('page='))
        anchors[i].href = anchors[i].href + '&rb_filter_metafield_b8d8fc4e5143be2d0daae1f33d4de73b=' + fitments
      }
  }
})

{
    document.querySelector('header.site-header').style.marginTop = '50px';
  }
  if (window.innerWidth <= 700) {

      if (sessionStorage.getItem('bikeName')) {
        // document.querySelector('li.mbSearch').style.marginTop = '-50px'
        document.querySelector('#hideMobile > div > ul > li > div').style.position = 'absolute';
        document.querySelector('#hideMobile > div > ul > li > div.search-wrapper').style.position = 'absolute';
        document.querySelector('#hideMobile > div > ul > li > div').style.marginLeft = '25px !improtant';
        document.querySelector('header.util .wrapper').style.padding = '6.5px 0';
    document.querySelector('#hideMobile > div > ul > li.mbSearch').style.marginTop = '-2px';
    document.querySelector('#hideMobile > div > ul > li.mbSearch').style.height = '40px';
    document.querySelector('header.site-header').style.marginTop = '0px';
        document.querySelector('.bike-name-mobile').style.display = 'flex';
        
      }
  } 

if (sessionStorage.getItem('bikeName')) {
    // document.querySelector('.search-bar').style.marginLeft = '0px'
    document.querySelector('#bike-remove').onclick = () => {
      sessionStorage.removeItem("bikeparams")
      sessionStorage.removeItem("bikeName")
      sessionStorage.removeItem("searchTerm")
      sessionStorage.removeItem("fitmentlist")
      document.querySelector('#bike-remove').style.display = 'none'
      document.querySelector('#bike-name').style.display = 'none'
      document.querySelector('.btn-success').style.display = 'none'
      document.querySelector('.btn-danger').style.display = 'none'
      document.querySelector('.bike-name span.icon').style.display = 'none'
  document.querySelector('#bike-remove').style.display = 'none'
  
    }
  if (window.location.pathname == "/"){
    // document.querySelector('.site-header.minimal').style.paddingTop = '45px';    
  }

  }
  
  // Listen for the search form submit event

 window.addEventListener('DOMContentLoaded', () => {
   let elms = document.querySelectorAll('li.snize-product')
console.log(elms)
for(let i=0; i<elms.length; i++)
{
console.log(elms[i].id.split('-')[2] ?? "no id")
}

    let fitments = document.querySelector('#fitlist').innerHTML.replaceAll('[','').replaceAll(']','').replaceAll('"','').split(',').map(item => item.trim())
  if(sessionStorage.getItem('bikeName') && !sessionStorage.getItem('fitments')) {
  sessionStorage.setItem('fitments',fitments)
  }

if (sessionStorage.getItem('searchTerm') && !window.location.search.includes('rb_filter_metafield') && window.location.pathname.includes('/pages/search-results-page') && !window.location.pathname.includes('/product')) {

  let fitmentParams = sessionStorage.getItem('fitments').split(',').map(i => i.replaceAll(' ','%20').replaceAll('\u0026','%26')).join('%7C')
  
  let filterURL = window.location.href + '&rb_filter_metafield_b8d8fc4e5143be2d0daae1f33d4de73b=' + fitmentParams
  console.log(filterURL)
}

if (sessionStorage.getItem('searchTerm') && !window.location.search.includes('rb_filter_metafield') && window.location.pathname == '/search' && window.location.pathname != '/' && !window.location.href.includes('/products') && !window.location.href.includes('/cart')) {
   document.body.style.display = 'none';

   if (document.querySelector('#snize_filters_block_filter_metafield_b8d8fc4e5143be2d0daae1f33d4de73b')) {
  // document.querySelector('#snize_filters_block_filter_metafield_b8d8fc4e5143be2d0daae1f33d4de73b').style.display = 'none'
  // document.querySelector('#snize_results > div.snize-filters-sidebar.snize-product-filters > div.snize-filters-title').style.display = 'none'
   }
 }

  function clearBikeCart () {
    let attys = {
      attributes: {}
    }

    attys.attributes['name'] = null;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(attys)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Handle the response as needed
      console.log('Cart updated:', data);
    })
    .catch(function(error) {
      console.error('Error updating cart:', error);
    });
  }

  if (document.querySelector('#bike-remove')) {
document.querySelector('#bike-remove').onclick = () => {
    clearBikeCart()
      sessionStorage.removeItem("fitments")
      sessionStorage.removeItem("bikeparams")
      sessionStorage.removeItem("bikeName")
      sessionStorage.removeItem("searchTerm")
      document.querySelector('#bike-remove').style.display = 'none'
      document.querySelector('#bike-name').style.display = 'none'
      document.querySelector('.bike-name').style.display = 'none'
  //     document.querySelector('.btn-success').style.display = 'none'
  //     document.querySelector('.btn-danger').style.display = 'none'
  document.querySelector('#bike-remove').style.display = 'none'
  document.querySelector('#remove-cross').style.display = 'none'
  setTimeout(()=>{
      window.location.reload()
      if (window.location.href.includes("page=")) {
        window.location.href = window.location.href.split('?')[0]
      } else {
        window.location.href = window.location.href.split('?')[0]
      }    
  },500)
      
    }
    }
  })
  if (sessionStorage.getItem('bikeName')) {
    document.querySelector('#bike-name').innerHTML = sessionStorage.getItem('bikeName')
  document.querySelector('#bike-remove').style.display = 'block'
    addEventListener("resize", () => {
      if (document.querySelector('.bike-button')) {
        
      document.querySelector('.bike-button').style.display = 'none';
      }
      if (window.innerWidth > 700) {

        if (!document.querySelector('#shopify-section-header > div:nth-child(2) > div > header > div > div.logo-nav-contain').style.marginTop) {

          //document.querySelector('header.site-header').style.marginTop = '50px';
        }
      }
      if (window.innerWidth < 701) {
      document.querySelector('.bike-name-mobile').style.display = 'flex';
        if (!document.querySelector('#shopify-section-header > div:nth-child(2) > div > header > div > div.logo-nav-contain').style.marginTop) {

          //document.querySelector('header.site-header').style.marginTop = '50px';
        }
      }
      })
  }
  if (!sessionStorage.getItem('bikeName')) {
  document.querySelector('#bike-remove').style.display = 'none';
  document.querySelector('#remove-cross').style.display = 'none';
  document.querySelector('.bike-name-header').style.display = 'none';
  document.querySelector('.name-container-mobile').style.display = 'none';
  }
